<template>
    <Main />
</template>

<script>
import Main from '@/components/Main'

export default {
    name: 'App',
    components: {
        Main,
    },
}
</script>

<style lang="scss">
@import './main.scss';
</style>
